import { SchemaYellowHiveQuote } from 'wg-api-sdk';
import { create } from 'zustand';

interface FlowsProductYellowhiveSelectionStore {
  selectedYellowhiveItems: SchemaYellowHiveQuote[];
  recalculatingProductIds: Set<string>;
  addToYellowhiveSelected: (item: SchemaYellowHiveQuote) => void;
  removeFromYellowhiveSelected: (yellowhive_product_id: string) => void;
  replaceYellowhiveSelected: (item: SchemaYellowHiveQuote) => void;
  addRecalculatingProductId: (productId: string) => void;
  removeRecalculatingProductId: (productId: string) => void;
  resetYellowhive: () => void;
}

const useYellowhiveFlowProductSelectionStore =
  create<FlowsProductYellowhiveSelectionStore>((set) => ({
    selectedYellowhiveItems: [],
    recalculatingProductIds: new Set<string>(),
    addToYellowhiveSelected: (item) =>
      set((state) => ({
        selectedYellowhiveItems: [...state.selectedYellowhiveItems, item],
      })),
    removeFromYellowhiveSelected: (yellowhive_product_id) =>
      set((state) => ({
        selectedYellowhiveItems: state.selectedYellowhiveItems.filter(
          (item) => item.yellowhive_product_id !== yellowhive_product_id,
        ),
      })),
    replaceYellowhiveSelected: (item) =>
      set((state) => ({
        selectedYellowhiveItems: state.selectedYellowhiveItems.map((oldItem) =>
          item.yellowhive_product_id === oldItem.yellowhive_product_id
            ? item
            : oldItem,
        ),
      })),
    addRecalculatingProductId: (productId) =>
      set((state) => ({
        recalculatingProductIds: new Set(state.recalculatingProductIds).add(
          productId,
        ),
      })),
    removeRecalculatingProductId: (productId) =>
      set((state) => {
        const newSet = new Set(state.recalculatingProductIds);
        newSet.delete(productId);
        return { recalculatingProductIds: newSet };
      }),
    resetYellowhive: () =>
      set(() => ({
        selectedYellowhiveItems: [],
        recalculatingProductIds: new Set<string>(),
      })),
  }));

export default useYellowhiveFlowProductSelectionStore;
